import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {MatIconModule} from '@angular/material/icon';
import {AlertCountDisplayComponent} from '../alert-count-display/alert-count-display.component';
import {MenuNavItem} from 'src/app/app.constants';
import {timer} from 'rxjs';
import {User} from 'src/app/core/model/user';
import {OphAvatarComponent} from 'src/app/shared/design/oph-avatar/oph-avatar.component';

@Component({
  selector: 'navbar-item',
  standalone: true,
  imports: [CommonModule, RouterModule, MatIconModule, AlertCountDisplayComponent, OphAvatarComponent],
  templateUrl: './navbar-item.component.html',
  styleUrl: './navbar-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavbarItemComponent {
  @Input() item: MenuNavItem;
  @Input() selected = false;
  @Input() isAvatarItem = false;
  @Input() user: User | null = null;

  @Output() itemClick = new EventEmitter();
  @Output() groupClick = new EventEmitter();

  onItem() {
    timer(100).subscribe(() => this.itemClick.emit());
  }

  onGroup() {
    this.groupClick.emit();
  }

  get isNavGroupItem() {
    return this.item.itemGroup !== undefined;
  }
}
